export default {
    'radarProjectId': 'cfb09b178a',
    'sampleRate': 1,
};
